<template>
<div class="fill df-col df-between">
  <div class="tab-wrap d-f c-white">
    <div :class="['tab-item', {active:actIndex === 0}]" @click="switchTab(0)">
      <t path="signinup_2"></t>
    </div>
    <div :class="['tab-item', {active:actIndex === 1}]" @click="switchTab(1)">
      <t path="signinup_3"></t>
    </div>
    <div :class="['s-line left',{'right': actIndex === 1}]"></div>
  </div>
  <div class="flex-1 pt-20">
    <SignUp v-if="actIndex === 0" @close="cb => $emit('close', cb)" />
    <SignIn v-if="actIndex === 1" @close="cb => $emit('close', cb)" />
  </div>
</div>
</template>

<script lang="ts">
import { googleLogin } from '@/features/googleLogin/googleLogin.api'
import { login } from '@/modules/user/user'
import { defineComponent, onBeforeMount, shallowRef } from 'vue'
import SignIn from '@/pages/login/SignIn.vue'
import SignUp from '@/pages/register/SignUp.vue'
import { callService } from '@/common/jsBridge.api'

export default defineComponent({
  name: 'TheLoginView',
  components: { SignIn, SignUp },
  props: {
    isLogin: {
      type: String,
      required: true,
    },
  },
  setup (props, ctx) {
    const actIndex = shallowRef(Number(props.isLogin === '1'))
    const switchTab = (index: number) => {
      actIndex.value = index
    }

    onBeforeMount(() => {
      (window as any).google?.accounts.id.initialize({
        client_id: '499094292366-nvju2cn3ltmdihsmqla9bn8dafve5k4g.apps.googleusercontent.com',
        callback (resp: any) {
          googleLogin({ idToken: resp.credential })
            .then(resp => {
              login(resp)
              ctx.emit('close')
            })
        },
      })

      ;(window as any).google?.accounts.id.prompt()
    })

    return {
      actIndex,
      switchTab,
      callService,
    }
  },
})
</script>

<style scoped lang="scss">
.tab-wrap {
  height: 40px;
  position: relative;

  .tab-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover,
    &.active {
      font-weight: bold;
    }

  }

}

.s-line {
  width: 48px;
  height: 2px;
  background-color: var(--color-white);
  position: absolute;
  bottom: 3px;
  transition: 0.3s;

  &.left {
    left: 25%;
    margin-left: -24px;
  }

  &.right {
    left: 75%;
    margin-left: -24px;
  }
}

::v-deep(.form > .form-item) {
  overflow: hidden;
  border: 1px solid var(--color-primary-thin);
  border-radius: 6px;
  color: var(--color-white);

  ::-webkit-input-placeholder {
    color: rgba(255, 255, 255, 0.5);
  }

  &::after {
    display: none;
  }

  &.invalid {
    border-color: var(--color-danger);
  }

  &:hover,
  &:focus-within {
    border-color: var(--color-white);
  }
}
</style>
